import { useTheme } from 'styled-components';
import type { CSSProperties } from 'react';

type PropsType = {
  overrideStyle?: CSSProperties;
};

const MapPinIcon = ({ overrideStyle = {} }: PropsType) => {
  const theme = useTheme();
  return (
    <svg
      viewBox="0 0 18 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: '18px', height: '23px', ...overrideStyle }}
    >
      <path
        d="M1 9.15A8.147 8.147 0 019.15 1a8.147 8.147 0 018.15 8.15c0 3.991-6.407 10.876-7.857 12.384a.401.401 0 01-.58 0C7.405 20.026 1 13.14 1 9.15z"
        stroke={overrideStyle.color || theme.Grey1}
        strokeWidth=".75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M9.143 12.758a3.385 3.385 0 100-6.77 3.385 3.385 0 000 6.77z"
        stroke={overrideStyle.color || theme.Grey1}
        strokeWidth=".75"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default MapPinIcon;
